<app-loading-spinner [active]="loadingContent"></app-loading-spinner>

<form [formGroup]="form">
    <div class="row">
        <div class="col-12 col-lg-4">
            <app-select [items]="signupService.nationalityChocies"
                [group]="form" controlName="country" label="País">
            </app-select>
            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-lg-4 cep-container">
            <app-masked-input [group]="form" controlName="cep" label="CEP"
                mask="00000-000" placeholder="00000-000"
                [showRequiredIndicator]="false"
                (input)="handleSearchZipcode($event)">
            </app-masked-input>
            <svg-icon src="assets/images/icon-loading.svg" *ngIf="loading"
                class="app-button-icon"></svg-icon>
        </div>
    </div>
    <app-spacer [bottom]="24"></app-spacer>

    <ng-container *ngIf="zipcodeFetched">
        <div class="row">
            <div class="col-12 col-lg-6">
                <app-input [group]="form" controlName="public_place"
                    label="Logradouro" [maxLength]="100">
                </app-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12 col-lg-2">
                <app-input [group]="form" controlName="number" label="Número"
                    [maxLength]="20">
                </app-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12 col-lg-4">
                <app-input [group]="form" controlName="complement"
                    [maxLength]="100" label="Complemento">
                </app-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-lg-6">
                <app-input [group]="form" controlName="district" label="Bairro"
                    [maxLength]="100">
                </app-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12 col-lg-3">
                <app-input [group]="form" controlName="city" label="Cidade"
                    [maxLength]="100">
                </app-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12 col-lg-3" *ngIf="isCountryBrazil()">
                <app-select [items]="states" [group]="form" controlName="uf"
                    label="UF">
                </app-select>
                <app-spacer [bottom]="24"></app-spacer>
            </div>
        </div>
    </ng-container>
</form>